import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import MetaTable from 'Components/UI/Meta/MetaTable';
import { usePageContentContext } from 'Views/Page/Contexts/PageContentContext';
import fr from 'facet-rest';
import LoadingIndicator from 'Components/UI/LoadingIndicator';
import Card from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Card';
import MetaFormInline from 'Components/UI/Meta/MetaForm/Components/MetaFormInline';
import TaskStatusViewLayout from 'Views/Page/Content/Templates/TaskStatusViewTemplate/MainPanel/TaskStatusViewLayout';
import { metaOverrideSet } from './metaOverrideSet';

const styles = () => ({
  root: {},
  fields: {},
});

const TaskDetails = ({
  resource,
}) => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    async function fetchData() {
      if (resource) {
        const accountCollection = await resource.relationship(fr.relationships.actionItem.name).link('related').get();
        setData(accountCollection);
      }
    }

    fetchData().finally(() => {
      setLoading(false);
    });
  }, []);
  if (loading) {
    return <LoadingIndicator />;
  }
  if (!data) {
    return null;
  }
  return (

    <React.Fragment>

      {data.resources().list().map((res) => {
        return (
          <Card key={res.id()}>
            <MetaFormInline
              resource={res}
              layout={TaskStatusViewLayout}
              metaOverrideSet={metaOverrideSet}
              readonly
            />
          </Card>
        );
      })
        }

    </React.Fragment>
  );
};
TaskDetails.propTypes = {
  resource: PropTypes.object.isRequired,
};


const MainPanel = ({
  className,
  classes,
}) => {
  const { pageContentCollection } = usePageContentContext();
  function handleExpanded(resource) {
    return (
      <TaskDetails
        resource={resource}
      />
    );
  }
  return (
    <MetaTable
      onExpanded={handleExpanded}
      className={classNames(className, classes.root)}
      classes={{ cell: classes.root }}
      collection={pageContentCollection}
      RowProps={{
        metaOverrideSet,
      }}
    />
  );
};

MainPanel.defaultProps = {
  className: '',
};

MainPanel.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(MainPanel);
